import {mapGetters} from "vuex";
import LogPropertiesResolver from "@/mixins/LogPropertiesResolver";

export default {
	mixins: [LogPropertiesResolver],
	data() {
		return {
			fallbackImagePath: '/typo3conf/ext/ig_warehouse/Resources/Public/Images/log-placeholder.png'
		}
	},
	computed: {
		...mapGetters(['watchlist']),
		teaserImage() {
			// always display chosen teaser if it was manually selected
			if(this.teaser && this.teaser !== '/' + this.object.localTeaser) {
				return this.teaser;
			}

			// if bundle images is turned off, display first small image / local backup teaser
			if (
				this.$route.meta.isPublic &&
				this.watchlist && !this.watchlist.dynamic && !this.watchlist.showBundleImages &&
				// do not fall back if this is a virtual item
				(!this.watchlistItem || !this.watchlistItem.virtual)
			) {
				return this.smallImages.length ? this.smallImages[0] : this.backupTeaser ? this.backupTeaser : false;
			}

			if(this.teaser === undefined) {
				if(this.smallImages.length) {
					return this.smallImages[0];
				}
				if(this.imageUrls.length) {
					return this.imageUrls[0].strImageURL;
				}
			}

			return this.teaser ? this.teaser : false;
		}
	}
}